export default __webpack_public_path__ + "static/media/Netherlands-vs-Ukraine.4d029efc.jpeg";